export default "__VITE_ASSET__Brmvz$N3__"